<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

interface SheetBodyProps {
  class?: HTMLAttributes['class'];
  padded?: boolean;
}

const props = withDefaults(defineProps<SheetBodyProps>(), {
  padded: false,
});
</script>

<template>
  <div data-slot="sheet-body" :class="cn(padded && 'px-10', props.class)">
    <slot />
  </div>
</template>
